import { render, staticRenderFns } from "./MpdIcon.vue?vue&type=template&id=2edbbbec&"
import script from "./MpdIcon.vue?vue&type=script&lang=js&"
export * from "./MpdIcon.vue?vue&type=script&lang=js&"
import style0 from "./MpdIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports